export function fieldPath(...parts) {
  return parts.join(".");
}
export function createFindingPath(auditId, auditItemId, findingId) {
  const child = fieldPath("audit_items", auditItemId, "deviations", findingId);
  return { doc: auditId, ref: "audits", child };
}

export function createFindingMediaPath(
  auditId,
  auditItemId,
  findingId,
  mediaId
) {
  const child = fieldPath(
    "audit_items",
    auditItemId,
    "deviations",
    findingId,
    "media",
    mediaId
  );
  return { doc: auditId, ref: "audits", child };
}

export function createAuditItemPath(auditId, auditItemId) {
  const child = fieldPath("audit_items", auditItemId);
  return { doc: auditId, ref: "audits", child };
}

export function errorIfFlase(expr, msg, errType) {
  errType = errType || Error;
  if (!expr) {
    throw new errType(msg);
  }
}
